import {
  Container,
  Dialog,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { FC } from "react";
import { FlexBox } from "./flex-box";
import CloseIcon from "@mui/icons-material/Close";
import { IconStore } from "components/icons/IconStore";
import { useBranchSelection } from "hooks/use-branch-selection";
import { colors } from "common";

interface Props {
  open?: boolean;
  onClose?: () => void;
}

export const BranchSelectDialog: FC<Props> = ({ open = false, onClose }) => {
  const { branchOptions, selectedBranch, setAsCurrentBranch } =
    useBranchSelection();

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <DialogContent sx={{ background: "#f7f9fc" }}>
        <Container>
          <FlexBox justifyContent={"space-between"}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Branches
            </Typography>
            <CloseIcon onClick={onClose} />
          </FlexBox>
          <List>
            {branchOptions.map((b) => (
              <ListItemButton
                sx={{
                  border: `${
                    b.id === selectedBranch?.id ? "3px" : "1px"
                  } solid ${
                    b.id === selectedBranch?.id
                      ? colors.lightBlue[500]
                      : "black"
                  }`,
                  background: "white",
                  borderRadius: "5px",
                  mt: "1em",
                }}
                key={b.branch_name}
                onClick={() => {
                  onClose();
                  setAsCurrentBranch(b);
                }}
              >
                <ListItemIcon>
                  <IconStore fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  {b.branch_name == selectedBranch.branch_name ? (
                    <Typography fontWeight={600}>
                      {`You're in `}
                      <span style={{ color: colors.skyBlue }}>
                        {b.branch_name}
                      </span>
                      {" Branch."}
                    </Typography>
                  ) : (
                    <Typography fontWeight={600}>
                      {`Switch to `}
                      <span style={{ color: colors.skyBlue }}>
                        {b.branch_name}
                      </span>
                      {" Branch."}
                    </Typography>
                  )}
                </ListItemText>
              </ListItemButton>
            ))}
          </List>
        </Container>
      </DialogContent>
    </Dialog>
  );
};
